import React from 'react';
import { motion } from 'framer-motion';
const bonos = [{
  icon: '🏃',
  title: 'Rutinas de 15 Minutos para el Alumno',
  value: '$12.000'
}, {
  icon: '📋',
  title: 'Ficha de Anamnesis para Adultos Mayores',
  value: '$9.000'
}, {
  icon: '📐',
  title: 'Guía de Variaciones en 3 Niveles',
  value: '$8.000'
}, {
  icon: '📅',
  title: 'Calendario Anual de Planificación',
  value: '$10.000'
}, {
  icon: '🎤',
  title: 'Script de Primera Clase con Adulto Mayor',
  value: '$9.000'
}];
export function BonosGrid() {
  return <section className="py-10 md:py-20 px-4 bg-white" data-id="element-25">
      <div className="max-w-5xl mx-auto" data-id="element-26">
        <div className="text-center mb-6 md:mb-12" data-id="element-27">
          <span className="bg-green-100 text-green-800 text-sm font-bold px-4 py-1.5 rounded-full uppercase tracking-wider mb-4 inline-block" data-id="element-28">
            INCLUIDOS GRATIS
          </span>
          <h2 className="font-display text-5xl text-navy-900 mb-4 tracking-wide uppercase" data-id="element-29">
            5 Bonos Estratégicos
          </h2>
          <p className="text-xl text-navy-600 font-medium" data-id="element-30">
            Sin costo extra — incluidos en todas las ofertas
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mb-6 md:mb-12" data-id="element-31">
          {bonos.map((bono, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.05
        }} className="bg-navy-50 p-6 rounded-xl border border-navy-100 flex flex-col items-center text-center hover:border-gold transition-colors" data-id="element-32">
              <div className="text-4xl mb-4" data-id="element-33">{bono.icon}</div>
              <h3 className="font-bold text-navy-900 mb-4 flex-grow" data-id="element-34">
                {bono.title}
              </h3>
              <div className="flex items-center gap-2 text-lg" data-id="element-35">
                <span className="text-navy-400 line-through" data-id="element-36">{bono.value}</span>
                <span className="font-black text-green-600 uppercase" data-id="element-37">
                  GRATIS
                </span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-navy-900 text-white p-6 md:p-8 rounded-2xl text-center shadow-xl" data-id="element-38">
          <h3 className="text-2xl md:text-3xl font-bold" data-id="element-39">
            VALOR TOTAL DE LOS 5 BONOS:{' '}
            <span className="line-through text-navy-300" data-id="element-40">$48.000</span>{' '}
            <span className="text-gold" data-id="element-41">GRATIS</span>
          </h3>
          <p className="text-navy-200 mt-2 font-medium" data-id="element-42">
            — Incluidos siempre —
          </p>
        </motion.div>
      </div>
    </section>;
}